import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Overline } from "@/components/site/Reveal";

export default function ImagineSection() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section className="relative bg-ocean-light/40 py-24 md:py-32" data-testid="imagine-section">
      <div className="mx-auto max-w-6xl px-6 lg:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <Overline className="text-sun">Daqui a alguns meses</Overline>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[1.04] tracking-tight text-brand-navy sm:text-5xl">
            Imagine olhar para trás daqui alguns meses...
          </h2>
        </Reveal>

        {/* Big parallax image */}
        <Reveal className="mt-14">
          <div ref={ref} className="relative aspect-[4/5] w-full overflow-hidden rounded-3xl shadow-2xl shadow-ocean-deep/25 sm:aspect-[16/11] lg:aspect-[16/10]">
            <motion.img
              src="/images/couple-diving-new.jpg"
              alt="Casal se olhando debaixo d'água em mergulho romântico"
              style={{ y }}
              className="absolute inset-0 h-[120%] w-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ocean-deep/70 via-transparent to-transparent" />
            <p className="absolute bottom-6 left-6 right-6 font-accent text-3xl text-white sm:text-4xl">
              “O melhor dia das nossas vidas.”
            </p>
          </div>
        </Reveal>

        <Reveal className="mx-auto mt-12 max-w-2xl text-center text-lg leading-relaxed text-brand-navy/80">
          <p>
            Enquanto muita gente vai pagar o preço cheio durante o verão, você já
            garantiu sua vaga pagando <strong className="text-brand-navy">metade do valor</strong>. Você compra agora,
            economiza e escolhe qualquer data dentro de 1 ano — inclusive finais de
            semana, feriados e durante o verão.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
